export default __webpack_public_path__ + "static/receipt-upload-6e93d87506c1af21741796db981d97f5.png";